export function formatDate(dateString?: string | null) {
    if (!dateString) '---';

    const date = new Date(dateString!);
    return date.toLocaleDateString();
}
